import { notification } from 'antd';
import { API } from 'utils/api';
import { handleSchedulerBegin, handleSchedulerError, handleSchedulerSuccess } from './exportScheduleActions';
import formatSchedulePayload from 'features/EventContainer/utils/formatSchedulePayload';
import * as panelService from 'utils/services/panels';

const resetScheduleAllSessions = async (Sessions) => {

  if (Sessions.length === 0) return Sessions;

  const uploadedSessions = Sessions.map((schedule) => {
   
    //pass null to reset sessions
    const formValues = {
      startTime: null,
      endTime: null,
    };
    const payload = formatSchedulePayload(schedule, formValues);

    return {
      schedule,
      payload
    };
  });

    var updatedPayload={data:[]};
    for (let i = 0; i < uploadedSessions.length; i++) {
      const {payload}=uploadedSessions[i];
      updatedPayload.data.push(payload);
    }

    try {
           await API.GetInstance().http.patch(`/api/sessions`, updatedPayload);   
    }catch (err) {
      notification.error({
        message: 'Error',
        description: `Error in reset sessions.`,
      });
     throw err;
    }
};

const deletePanels = async (panelData) => {
  if (!Array.isArray(panelData) || panelData.length === 0) return panelData;

  try {
    // Use Promise.all to run all delete operations concurrently
    await Promise.all(
      panelData.map(async (panel) => {
        await panelService.deletePanelByID(panel.id);
      })
    );
  } catch (err) {
    notification.error({
      message: 'Error',
      description: 'Error in deleting panels',
    });
    throw err;
  }

  return panelData;
};


export const handleResetSession = (cb = () => {}) => {
  return async (dispatch, getState) => {
    const { event: {eportEventSchedule,eventSchedule}} = getState();
    const {eventCereMony,judgingSession,matchesSession} = eportEventSchedule;
    const {sessions:{scoringPanelData,judgingPanelData}} = eventSchedule;   
   
     const sessionData=[];
     const panelsData=[];

    try {
        await dispatch(handleSchedulerBegin());

        sessionData.push(eventCereMony.openCeremony);
        sessionData.push(eventCereMony.closeCeremony);
        sessionData.push(...judgingSession);
        sessionData.push(...matchesSession);

        panelsData.push(...scoringPanelData);
        panelsData.push(...judgingPanelData);
  
        await resetScheduleAllSessions(sessionData);

        await deletePanels(panelsData);

        await dispatch(handleSchedulerSuccess());
      cb();
    } catch (err) {
       await dispatch(handleSchedulerError());
    }
  };
};
